import { render, staticRenderFns } from "./ImportFileUpload.vue?vue&type=template&id=1f0728f4&"
import script from "./ImportFileUpload.vue?vue&type=script&lang=js&"
export * from "./ImportFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports